import { message } from 'antd';
import { RcFile } from 'antd/lib/upload';

export function checkFileIsImage(file: RcFile): boolean {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('Aplikace podporuje pouze obrázky ve formátu JPG nebo PNG');
  }

  return isJpgOrPng;
}
